export default __webpack_public_path__ + "static/media/saas.b8119028.jpg";